//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import EmailEditor from "@Shared/components/inputs/email-editor";
import BulkRequestModalLoader from "../bulk-request-modal-loader";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomizeMessageStep",
  components: {
    BulkRequestModalLoader,
    InlinePrompt,
    EmailEditor
  },
  props: {
    userMessage: {
      type: String,
      required: true
    },
    documentRequestTemplates: {
      type: Object,
      default: () => ({})
    },
    autoSelectedEmailTemplate: {
      type: [String, Number],
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedEmailTemplate: "",
      newTemplateName: "",
      showSettings: false
    };
  },
  computed: {
    isValid() {
      return true;
    },
    computedUserMessage: {
      get() {
        return this.userMessage;
      },
      set(value) {
        this.$emit("add-email-user-message", value);
      }
    },
    emptyDocumentRequestTemplates() {
      return isEmpty(this.documentRequestTemplates.byId);
    },
    allowSaveNew() {
      return this.newTemplateName && this.userMessage;
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    },
    autoSelectedEmailTemplate(value) {
      this.selectedEmailTemplate = value;
      this.$nextTick(() => {
        this.$refs.emailEditor.setHtml(this.userMessage);
      });
    }
  },
  mounted() {
    this.selectedEmailTemplate = this.autoSelectedEmailTemplate;
  },
  methods: {
    handleTemplateSelected({
      target
    }) {
      const templateId = target.value || "";
      this.selectedEmailTemplate = templateId;
      this.newTemplateName = templateId ? this.documentRequestTemplates.byId[templateId].name : "";
      this.$emit("select-email-template", templateId);
    },
    handleUpdateTemplate() {
      this.$emit("update-email-template", {
        templateId: this.selectedEmailTemplate,
        name: this.newTemplateName
      });
    },
    handleDeleteTemplate() {
      this.$emit("delete-email-template", this.selectedEmailTemplate);
      this.selectedEmailTemplate = "";
      this.newTemplateName = "";
    },
    handleSaveNewTemplate() {
      this.$emit("create-email-template", this.newTemplateName);
      this.newTemplateName = "";
    },
    updateUserMessage({
      content
    }) {
      this.computedUserMessage = content;
    }
  }
});